import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import React from 'react';

import ButtonDefault, {
  ButtonVariants,
} from '../../components/shared/basic/button';

interface Props {
  results: string[];
}

const ResultPage: React.FC<Props> = ({ results }) => {
  const screens = useBreakpoint();

  const router = useRouter();

  return (
    <div className='flex flex-col w-full'>
      <span className='flex flex-col items-center'>
        {results?.map((_: string, index: number) => {
          return (
            <div
              key={index}
              className={clsx(
                index % 2 === 0 && 'text-[#166FF6]',
                'text-[46px] font-semibold  uppercase leading-[42px]',
              )}
            >
              {results.map((item) => item[0]).join('')}
            </div>
          );
        })}
      </span>
      <div className='flex justify-start w-full mt-12'>
        <span className='flex flex-col items-start '>
          <p className='text-xl'>Your reading personality:</p>
          <span className='flex flex-col gap-y-3 mt-8'>
            {results?.map((item: string, index: number) => {
              return (
                <div
                  key={index}
                  className={clsx('text-base font-semibold uppercase ')}
                >
                  <p className='text-[#166FF6] inline-flex'>{item[0]}</p>
                  {item.slice(1)}
                </div>
              );
            })}
          </span>
        </span>
      </div>
      <div className='flex flex-col gap-y-2 mt-14'>
        <ButtonDefault
          size={screens.md ? 2 : 1}
          rounded={false}
          variant={ButtonVariants.WHITE}
          enableScaling={false}
          onClick={() => {
            router.push(
              `/reader-personality-test/${results?.map((item) => item[0]?.toUpperCase()).join('')}`,
            );
          }}
          className='w-full text-center text-sm p-3 '
        >
          <span className='md:px-1 py-1 font-semibold whitespace-nowrap'>
            Learn More about{' '}
            {results?.map((item) => item[0]?.toUpperCase()).join('')}
          </span>
        </ButtonDefault>
        <ButtonDefault
          size={screens.md ? 2 : 1}
          rounded={false}
          variant={ButtonVariants.GRAY}
          enableScaling={false}
          onClick={() => router.push(`/`)}
          className='w-full text-center text-sm p-3 '
        >
          <span className='md:px-1 py-1 font-semibold whitespace-nowrap'>
            Read a Free Book
          </span>
        </ButtonDefault>
      </div>
    </div>
  );
};

export default ResultPage;
